import MasterSettingAgreement36Page from './MasterSettingAgreement36Page';

export default MasterSettingAgreement36Page;